export default {
  state: {
    filterBy: null,
    filterTo: null,
    events: [],
    selectedEvent: '',
  },
  getters: {
    selectedEvent: (state) => state.selectedEvent,
    filterTime: (state) => state.filterBy,
    eventTo: (state) => state.filterTo,
    eventsReverse: (state) => state.events.slice().reverse(),
  },
  mutations: {
    updateSelectedEvent(state, payload) {
      state.selectedEvent = payload;
    },
    updateEvents(state, payload) {
      if (payload === null) {
        state.events = [];
      } else {
        const newEvents = JSON.parse(payload).events;

        const allEvents = [...state.events, ...newEvents];
        const seen = new Set();
        state.events = allEvents.filter((event) => {
          const key = event?.data?.s;
          if (!key) return true;
          if (seen.has(key)) return false;
          seen.add(key);
          return true;
        });
      }
    },
    updateFilter(state, payload) {
      state.filterBy = payload;
    },
    updateFilterTo(state, payload) {
      state.filterTo = payload;
    },
  },
  actions: {
    selectEvent({ commit }, payload) {
      commit('updateSelectedEvent', payload);
    },
    changeEvents({ commit }, payload) {
      commit('updateEvents', payload);
    },
    ChangeFilter({ commit }, payload) {
      const time = Date.now() - payload;

      commit('updateFilter', time);
    },
    changeStartTime({ commit }, payload) {
      commit('updateFilter', payload);
    },
    changeEndTime({ commit }, payload) {
      commit('updateFilterTo', payload);
    },
  },
};
